module.exports = __webpack_public_path__ + "c501fd3a1453b29bbacfd3434638dac6.png";